export enum AbortActionEnum {
  DELETE = "del",
  GET = "get",
  POST = "post",
  PUT = "put",
  PATCH = "patch",
  EXPORT = "export",
  BLOB = "blob",
}
